enum ChangeStatus {
  Added,
  Deleted,
  Updated
}

export default ChangeStatus
